import { cx } from 'cva'
import type { FC, PropsWithChildren, ReactNode } from 'react'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'

export type ColumnsBlockProps = {
	columnLeft: ReactNode
	columnLayout: 'default' | 'reverse'
}

export const ColumnsBlock: FC<PropsWithChildren<ColumnsBlockProps>> = ({
	columnLeft,
	columnLayout,
	children,
}) => {
	const leftClasses =
		'col-span-full tablet-l:row-start-1 layout-narrow:tablet-l:col-start-1 layout-narrow:tablet-l:col-span-4 layout-wide:tablet-l:col-span-6'
	const rightClasses =
		'col-span-full tablet-l:row-start-1 layout-narrow:tablet-l:col-start-5 layout-narrow:tablet-l:col-span-4 layout-wide:tablet-l:col-start-7 layout-wide:tablet-l:col-span-6'

	const defaultLeft = columnLayout === 'default' ? leftClasses : rightClasses
	const defaultRight = columnLayout === 'default' ? rightClasses : leftClasses

	return (
		<ContentBlockWrapper blockTypes={['component']} gridClassName="gap-y-4xl" layout="nested">
			<div className={cx(defaultLeft, 'row-start-2')}>{columnLeft}</div>
			<div
				className={cx(
					defaultRight,
					'row-start-1',
					columnLayout === 'default'
						? 'tablet-l:pl-two-column-extra'
						: 'tablet-l:pr-two-column-extra',
				)}
			>
				{children}
			</div>
		</ContentBlockWrapper>
	)
}
